@use "variables" as *;

.description {
  font-size: $fontSize-m;
}

.searchBar {
  justify-content: center;
}

.gridCard {
  position: relative;
  padding: $spacing-m;
  height: 100%;
  overflow: auto !important;
}

.checkboxHelpText {
  font-size: $fontSize-s;
  font-weight: normal;
}
